const serverURL = import.meta.env.VITE_API_URL

export async function fetchRegions(token: string) {
  const response = await fetch(`${serverURL}/regions/`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const regions = await response.json()

  return regions
}

export async function fetchRegionSets(token: string) {
  const response = await fetch(`${serverURL}/regions/sets`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const regionSets = await response.json()

  return regionSets
}

export interface RegionOpportunityCountRequest {
  region_ids: number[]
  accepts_gambling_proceeds: boolean
  accepts_international: boolean
  iwi_ids?: number[]
}

export async function fetchRegionOpportunityCount(
  token: string,
  payload: RegionOpportunityCountRequest,
) {
  const response = await fetch(`${serverURL}/regions/opportunity-count`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const data = await response.json()
  return data.count as number
}
